"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkExitIsValid = exports.checkExitIsCheckpointed = exports.exitFundsFromMaticAndForward = exports.exitFundsFromMatic = exports.multipleExitFundsFromMatic = void 0;
var abi_1 = require("@ethersproject/abi");
var providers_1 = require("@ethersproject/providers");
var matic_proofs_1 = require("@tomfrench/matic-proofs");
var transferErc20_1 = require("../utils/transferErc20");
var types_1 = require("../types");
var encodeExit = function (exitData) {
    return new abi_1.Interface(["function exit(bytes)"]).encodeFunctionData("exit(bytes)", [exitData]);
};
/**
 * @notice Generates the transaction object for an exit transaction to be send to the proxy wallet
 * @param rootChainProviderUrl - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProviderUrl - The url of the JSONRpcProvider used for querying the child chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHash - the burn transaction hash corresponding to the withdrawal
 */
var exitTransaction = function (rootChainProviderUrl, maticChainProviderUrl, rootChainManagerAddress, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () {
    var exitPayload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, matic_proofs_1.buildPayloadForExit(new providers_1.JsonRpcProvider(rootChainProviderUrl), new providers_1.JsonRpcProvider(maticChainProviderUrl), rootChainManagerAddress, burnTxHash, matic_proofs_1.ERC20_TRANSFER_EVENT_SIG)];
            case 1:
                exitPayload = _a.sent();
                return [2 /*return*/, {
                        to: rootChainManagerAddress,
                        typeCode: types_1.CallType.Call,
                        data: encodeExit(matic_proofs_1.encodePayload(exitPayload)),
                        value: "0",
                    }];
        }
    });
}); };
/**
 * @notice Submits multiple withdrawal proofs to the mainnet Matic contracts claiming the funds to the users proxyWallet
 * @param rootChainProviderUrl - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProviderUrl - The url of the JSONRpcProvider used for querying the child chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHashes - an array of burn transaction hashes corresponding to withdrawals
 */
exports.multipleExitFundsFromMatic = function (rootChainProvider, maticChainProvider, rootChainManagerAddress, burnTxHashes) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.all(burnTxHashes.map(function (burnTxHash) {
                return exitTransaction(rootChainProvider, maticChainProvider, rootChainManagerAddress, burnTxHash);
            }))];
    });
}); };
/**
 * @notice Submits a withdrawal proof to the mainnet Matic contracts claiming the funds to the users proxyWallet
 * @param rootChainProviderUrl - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProviderUrl - The url of the JSONRpcProvider used for querying the child chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHash - the burn transaction hash corresponding to the withdrawal
 */
exports.exitFundsFromMatic = function (rootChainProvider, maticChainProvider, rootChainManagerAddress, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, exports.multipleExitFundsFromMatic(rootChainProvider, maticChainProvider, rootChainManagerAddress, [burnTxHash])];
}); }); };
/**
 *
 * @param rootChainProvider - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProvider - The url of the JSONRpcProvider used for querying the root chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHash - the transaction hash to be tested
 * @param recipientAddress - the address to forward the withdrawn funds to
 * @param expectedWithdrawalAmount - the amount in wei of withdrawn funds to transfer to recipientAddress
 */
exports.exitFundsFromMaticAndForward = function (rootChainProviderUrl, maticChainProviderUrl, rootChainManagerAddress, burnTxHash, tokenAddress, recipientAddress, expectedWithdrawalAmount) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // TODO: We can pull the tokenAddress and expectedWithdrawalAmount from onchain
        return [2 /*return*/, Promise.all([
                exitTransaction(rootChainProviderUrl, maticChainProviderUrl, rootChainManagerAddress, burnTxHash),
                transferErc20_1.erc20TransferTransaction(tokenAddress, recipientAddress, expectedWithdrawalAmount),
            ])];
    });
}); };
/**
 * @notice Checks whether the provided burn transaction hash is included in a checkpoint
 * @param rootChainProviderUrl - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProviderUrl - The url of the JSONRpcProvider used for querying the child chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHash - the transaction hash to be tested
 */
exports.checkExitIsCheckpointed = function (rootChainProviderUrl, maticChainProviderUrl, rootChainManagerAddress, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () {
    var rootChainProvider, maticChainProvider;
    return __generator(this, function (_a) {
        rootChainProvider = new providers_1.JsonRpcProvider(rootChainProviderUrl);
        maticChainProvider = new providers_1.JsonRpcProvider(maticChainProviderUrl);
        return [2 /*return*/, matic_proofs_1.isBurnTxCheckpointed(rootChainProvider, maticChainProvider, rootChainManagerAddress, burnTxHash)];
    });
}); };
/**
 * @notice Checks whether the provided burn transaction hash is able to be successfully claimed.
 *         i.e. whether it is included in a checkpoint and hasn't already been claimed.
 * @param rootChainProviderUrl - The url of the JSONRpcProvider used for querying the root chain
 * @param maticChainProviderUrl - The url of the JSONRpcProvider used for querying the child chain
 * @param rootChainManagerAddress - The address of the rootchain manager contract
 * @param burnTxHash - the transaction hash to be tested
 */
exports.checkExitIsValid = function (rootChainProviderUrl, maticChainProviderUrl, rootChainManagerAddress, burnTxHash) { return __awaiter(void 0, void 0, void 0, function () {
    var rootChainProvider, maticChainProvider;
    return __generator(this, function (_a) {
        rootChainProvider = new providers_1.JsonRpcProvider(rootChainProviderUrl);
        maticChainProvider = new providers_1.JsonRpcProvider(maticChainProviderUrl);
        return [2 /*return*/, matic_proofs_1.isBurnTxClaimable(rootChainProvider, maticChainProvider, rootChainManagerAddress, burnTxHash, matic_proofs_1.ERC20_TRANSFER_EVENT_SIG)];
    });
}); };
